import { Component } from '@angular/core';
import { ColumnSort, ColumnType, DataTableColumn, DataTableMultiColumnFilter, DataTableRow } from '../controls/datatable/datatable.component';
import { EventService } from 'src/app/service/event.service';
import { SoftwareInventoryService } from 'src/app/service/software-inventory.service';
import { DataService } from 'src/app/service/data.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Events, MsgPayLoad } from 'src/app/service/websocket.service';
import { Modal } from '../controls/modal/modal.service';
import { PageEvent, PageCount } from '../controls/pagination/pagination.component';
import { ProductDataType, ProductTreeType } from '../products/products.component';
import { Subscription, tap } from 'rxjs';
import { SolutionInfo } from 'src/app/model/SolutionInfo';
import { ActionMenuEvent, ActionMenuIcon, ActionMenuItem } from '../controls/actionmenu/action-menu.component';
import { DiscoveredProduct, PatchExt, ProductExt } from 'src/app/model/Product';
import { ObjectDetailsComponent, ObjectDetailsTypes } from '../dialogs/object-details/object-details.component';
import { ModalControl, ModalControlType, ModalMessageComponent, ModalResult } from '../controls/modal-message/modal-message.component';
import { Utils } from 'src/app/utils';

export enum ProductSearchField {
  ID = "id",
  NAME = "prefix",
  PRODUCTNAME = "productName",
  PRODUCTVERSION = "productVersion",
  REQUESTBY = "initiatorUserName",
  CREATED = "createdDateTime",
  LASTUPDATED = "updatedDateTime",
  SIZE = "fileSize",
  STATUS = "status",
  DOWNLOAD = "downloadUrl"
}

@Component({
    selector: 'app-product-search-hotfix',
    templateUrl: './product-search-hotfix.component.html',
    styleUrls: ['./product-search-hotfix.component.css'],
    standalone: false
})
export class ProductSearchHotfixComponent {
  solutionInfo: SolutionInfo;
  cols: DataTableColumn[] = Array<DataTableColumn>(
    new DataTableColumn("name", $localize`Name`, ColumnType.STRING, true, "11", ColumnSort.DESC, undefined, undefined, true, new DataTableMultiColumnFilter($localize`Search name`)),
    new DataTableColumn("description", $localize`Description`, ColumnType.STRING, false, "25", undefined, undefined, undefined, false, new DataTableMultiColumnFilter($localize`Search description`)),
    new DataTableColumn("modules", $localize`Modules`, ColumnType.STRING, false, "11", undefined, undefined, undefined, false, new DataTableMultiColumnFilter($localize`Search modules`)),
    new DataTableColumn("updates", $localize`Requires`, ColumnType.STRING, false, "11", undefined, undefined, undefined, false, new DataTableMultiColumnFilter($localize`Search requires`)),
    new DataTableColumn("supersedes", $localize`Supersedes`, ColumnType.STRING, false, "11", undefined, undefined, undefined, false, new DataTableMultiColumnFilter($localize`Search supersedes`)),
    new DataTableColumn("supersededBy", $localize`Superseded by`, ColumnType.STRING, false, "13", undefined, undefined, undefined, false, new DataTableMultiColumnFilter($localize`Search superseded by`)),
    new DataTableColumn("dependents", $localize`Dependents`, ColumnType.STRING, false, "11", undefined, undefined, undefined, false, new DataTableMultiColumnFilter($localize`Search superseded by`)),
    new DataTableColumn("status", $localize`Status`, ColumnType.STATUSEXT, false, "7"),
  );
  rows: DataTableRow[] = [];
  isManifestUpdating: boolean = false;
  isLoading: boolean = true;
  routeSubscription: Subscription;
  solutionInfoSubscription: Subscription;
  eventMessageSubscription: Subscription;
  dataSubscription: Subscription;
  pageInfo: PageEvent = new PageEvent(1, 0, PageCount.TWENTYFIVE);
  total: number = 0;
  productId:number;
  platform: string;
  productGroupId:number;
  tableTitle: string;
  isDecendingOrder: boolean = true;
  loading: boolean = true;
  multiColFilter:Object  = new Object();

  constructor(protected eventService: EventService,
    protected siService:SoftwareInventoryService,
    protected dataService:DataService,
    protected router: Router,
    protected modal: Modal,
    public route: ActivatedRoute) {
      this.dataSubscription = this.dataService.getData().subscribe((data:any) => {
        if(data && (data.type == ProductDataType.General || data.type == ProductDataType.QuickAnalysis)){
          this.solutionInfo = data.solutionInfo;
          if(this.isLoading){
            this.isManifestUpdating = this.solutionInfo.manifestStatus.isUpdating;
          }
          const discoveredProductGroup : DiscoveredProduct[] = data.discoveredProductGroup;

          for(let i = 0; i < discoveredProductGroup.length; i++) {
            let foundProd:ProductExt[] = (discoveredProductGroup[i].products.filter((prod:ProductExt) => {
              return prod.id == this.productId;
            }));
            if(foundProd.length > 0){
              this.platform = foundProd[0].platform;
              this.productGroupId = foundProd[0].groupId;
              this.tableTitle = $localize`Search Patches for ${foundProd[0].name}`;
              this.dataService.sendData({type: ProductDataType.Title, title: this.tableTitle});
              this.dataService.sendData({type: ProductDataType.SelectTree, select: {type: ProductTreeType.HOTFIX_SEARCH, productGroupId: this.productGroupId, productId: this.productId}});
              this.searchHotfixes(this.multiColFilter);
              break;
            }
          }
          this.loading = false;
        }
      });

      this.solutionInfoSubscription = this.eventService.currentSolutionInfo$.subscribe(newSolutionInfo => {
        this.solutionInfo = newSolutionInfo;
      });

      this.eventMessageSubscription = this.eventService.eventMessage$.subscribe(msg => {
        if (msg.eventType == Events.ManifestUpdateStarted) {
          this.isManifestUpdating = true;
        } else if (msg.eventType == Events.ManifestUpdateComplete) {
          this.isManifestUpdating = false;
        }
      });
  }

  ngOnInit(): void {
    this.routeSubscription = this.route.params.subscribe(params => {
      this.productId = +params['productId'];
    });
  }

  ngOnDestroy() {
    if (this.solutionInfoSubscription != undefined) {
      this.solutionInfoSubscription.unsubscribe();
    }
    if (this.eventMessageSubscription != undefined) {
      this.eventMessageSubscription.unsubscribe();
    }
    if (this.dataSubscription != undefined) {
      this.dataSubscription.unsubscribe();
    }
  }

  searchHotfixes(multiFilterColFilter?: any): void {
    this.isLoading = true;
    let tmpProducts: DataTableRow[] = [];
    this.siService.searchHotfixes(this.productId, this.solutionInfo.currentEnvironment.id, this.platform,
      this.pageInfo.startingIndex, this.pageInfo.itemsPerPage,this.isDecendingOrder, multiFilterColFilter).pipe(
      tap(resp => {
        let response = resp.body;
        this.total = response.count;
        response.hotfixes.forEach((patch: PatchExt) => {
          let row = new DataTableRow({ name: patch.name, description: patch.description, modules: patch.extraInfo.modules,
                                       patch: patch, updates: patch.extraInfo.updates, supersedes: patch.extraInfo.supersedes,
                                       supersededBy: patch.extraInfo.supersededBy, dependents: patch.extraInfo.dependents,
                                        status: this.getStatus(patch) ,
                                        retired: patch.details.retired ? $localize`Yes` : $localize`No` },
                                        [new ActionMenuItem("Details", $localize`Details`, ActionMenuIcon.DETAILS, patch, false, true),
                                        new ActionMenuItem("Export", $localize`Export metadata`, ActionMenuIcon.SHARE, patch, true, false)], 
                                        false, false, false);
          tmpProducts.push(row);
        });
        this.rows = tmpProducts;
        this.isLoading = false;
      })).subscribe();
  }

  exportMetadata(selectedPatches:any):void {
    if(selectedPatches.length > 0){
      if(selectedPatches[0].patch !== undefined){
        let tmpSelectedPatches:PatchExt[] = [];
        selectedPatches.forEach( selectedPatch => {
          tmpSelectedPatches.push(selectedPatch.patch);
        });
        selectedPatches = tmpSelectedPatches;
      }
      let exportTypeRadioControl: ModalControl = new ModalControl('export-types', ModalControlType.RADIO,
                                                                  undefined, 
                                                                  {label: $localize`Select file type`,
                                                                    selectedOption: 'CSV',
                                                                   options: 
                                                                    [{key: 'CSV', value: $localize`CSV (comma-separated values)`},
                                                                     {key: 'HTML', value: $localize`HTML`},
                                                                    ]
                                                                  });
      const sub: Subscription =
      this.modal.open(ModalMessageComponent, {
        data: {
                title: $localize`Export metadata`,
                message: selectedPatches.length == 1 ? $localize`Metadata for the selected item will be downloaded. Download the metadata?` :
                                                      $localize`Metadata for the selected ${selectedPatches.length} items will be downloaded. Download the metadata?`,
                primaryBtn: $localize`Download`,
                secondaryBtn: $localize`Cancel`,
                controls: [exportTypeRadioControl],
                width: '450px',
                useResult: true
              },
        id: 'otsc-products-searchhotfix-export-metadata-msg'
        }
      ).afterClosed.subscribe((result: ModalResult) => {
        if(result.isPrimary){
          this.sendExportMetadataRequest(selectedPatches, result.controls[0].val.selectedOption);
        }
        sub.unsubscribe();
      });
    }
  }

  private sendExportMetadataRequest(selectedPatches:PatchExt[], type: 'CSV' | 'HTML'): void {
    this.siService.exportToFile(selectedPatches, [], type, true, this.isDecendingOrder).pipe(
      tap(resp => {
        let msg:MsgPayLoad;

        if(resp.body.status && resp.body.status.success){
          msg = new MsgPayLoad(undefined,{
            message: $localize`Metadata was exported successfully. Please check your download folder.` 
          });
          msg.setEvent(Events.SuccessMsg);
          setTimeout(() => {
            window.open(resp.body.result.data.url, "_self");
          }, 500);
        }else{
          msg = new MsgPayLoad(undefined,{
            message: $localize`Metadata failed to exported. See the log for details.`
          });
          msg.setEvent(Events.ErrorMsg);
        }
        
        Utils.addHeaderMessageBanner(this.eventService, msg);
      })).subscribe();
  }
  
  showPage(): boolean {
    return (!this.loading && !this.isManifestUpdating);
  }

  onPageChange(pageEvent: PageEvent) {
    this.pageInfo = pageEvent
    this.searchHotfixes(this.multiColFilter);
  }

  sortHotfixes(col: DataTableColumn) {
    this.isDecendingOrder = col.sortDirection == ColumnSort.DESC;
    this.pageInfo.pagenum = 1;
    this.pageInfo.startingIndex = 0;
    this.searchHotfixes(this.multiColFilter);
  }

  actionMenuClicked(event: ActionMenuEvent): void {
    switch (event.name) {
      case "Details":
        this.openDetails(event.data[0]);
        break;
      case "Export":
        this.exportMetadata(event.data);
        break;
    }
  }

  onMultiFilterChanged(cols: DataTableColumn[]): void {
    this.multiColFilter = new Object();
    this.pageInfo.pagenum = 1;
    this.pageInfo.startingIndex = 0;

    cols.forEach((col) => {
      if(col.isMultiColumnFilter()){
        this.multiColFilter[col.field] = col.multiColumnFilter.value;
      }
    });

    this.searchHotfixes(this.multiColFilter);
  }

  private getStatus(patch): any {
    let status:any;

    if(patch.details.retired){
      status = {className: 'otsc-icon-status-outdated', altText: $localize`Retired`} 
    } else {
      status = {className: 'otsc-icon-status-available-download', altText: $localize`Available for download`};
    }

    return status;
  }

  private openDetails(pkg: any){
    this.modal.open(ObjectDetailsComponent, {
      data: { 
        obj: pkg.patch ? pkg.patch : pkg,
        type: ObjectDetailsTypes.PATCH
      },
      id: 'otsc-products-search-patches-details-dialog'
    });
  }
}